export const getRolePrefix = (roleName: string): string => {
  if (!roleName) return "";
  return "/" + roleName.toLowerCase().replace(/\s+/g, "-");
};

export const RoutesLink = {
  // Auth Routes
  authRoutes: {
    login: "/",
    ssoLogin: "/sso-login",
    forgot: "/forgot",
    signUp: "/join-now",
    verifyOtp: "/verify-otp",
    resetPassword: "/reset-password",
  },
  forbidden_403: "/forbidden-403",
  // user
  userDashboard: "/dashboard",
  superAdminDashboard: "/dashboard",
  superAdminOnboard: "/onboard",
  superAdminEmplyoeeOnboard: "/employee-onboard",
  addEmplyoeeOnboard: "/add-employee-onboard",
  editEmplyoeeOnboard: "/edit-employee-onboard",
  createEmployee: "/create-employee",
  editEmployee: "/edit-employee",
  employeeDetail: "/employee-detail",
  bulkImportEmployee: "/bulk-import-employee",

  // salary head
  salaryHead: "/salary-head",
  addSalaryHead: "/add-salary-head",
  editSalaryHead: "/edit-salary-head",
  SalaryHeadDetails: "/salary-head-detail",

  // branch salary head
  branchSalaryHead: "/branch-salary-head",
  addBranchSalaryHead: "/add-branch-salary-head",
  editBranchSalaryHead: "/edit-branch-salary-head",
  branchSalaryBackup: "/branch-salary-backup",

  // Profile
  profile: "/profile",
  editProfile: "/edit-profile",
  notification: "/notification",
  // viewProfile: "/view-profile/",

  // attendance
  myAttendance: "/my-attendance",
  monthlyTeamAttendanceSummary: "/monthly-team-attendance-summary",
  teamAttendance: "/team-attendance",
  attendanceLog: "/attendance-log",
  dailyTeamAttendance: "/daily-team-attendance",
  monthlyTeamAttendance: "/monthly-team-attendance",
  monthlySalaryPreview: "/monthly-salary-preview",
  manageMonthlyBulkAttendance: "/manage-monthly-bulk-attendance",

  // transfer
  transfer: "/transfer",

  // WFH
  addWfh: "/add-wfh",
  editWfh: "/edit-wfh",
  wfhRequest: "/wfh-request",
  teamWfh: "/wfh-team",
  wfhDetail: "/wfh-detail",
  teamWfhDetail: "/wfh-team-detail",

  // Payslip
  payslip: "/payslip",
  teamsPayslip: "/teams-payslip",
  payslipDetail: "/payslip/detail",

  // OD
  myOd: "/od-request",
  teamOd: "/od-team",
  createOd: "/create-od",
  odDetail: "/od-detail",
  teamOdDetail: "/team-od-detail",
  editOd: "/edit-od",

  //   organisation
  superAdminOrganisation: "/organisation",
  addOrganisation: "/add-organisation",
  editOrganisation: "/edit-organisation",

  //regularization
  myRegularization: "/regularization-request",
  teamRegularization: "/regularization-team",
  createRegularization: "/create-regularization",
  regularizationDetail: "/regularization-detail",
  teamsRegularizationDetail: "/team-regularization-detail",
  editRegularization: "/edit-regularization",
  // teamRegularizationDetail: "/team-regularization-detail",

  // Company
  company: "/company",
  createCompany: "/create-company",
  editCompany: "/edit-company",

  //   department
  superAdminDepartment: "/department",
  addDepartment: "/add-department",
  editDepartment: "/edit-department",
  //   branch
  superAdminBranch: "/branch",
  addBranch: "/add-branch",
  editBranch: "/edit-branch",
  //   shift and time
  shiftAndTime: "/shift-and-time",
  addShiftAndTime: "/add-shift-and-time",
  editShiftAndTime: "/edit-shift-and-time",
  viewShiftAndTime: "/view-shift-and-time",

  //   designation
  superAdminDesignation: "/designation",
  addDesignation: "/add-designation",
  editDesignation: "/edit-designation",

  // campus
  superAdminCampus: "/campus",
  addCampus: "/add-campus",
  editCampus: "/edit-campus",

  // applications
  superAdminApplication: "/application",
  addApplication: "/add-application",
  editApplication: "/edit-application",

  // holiday
  superAdminHoliday: "/manage-holidays",
  addHoliday: "/add-holiday",
  editHoliday: "/edit-holiday",
  holidayList: "/holidays",

  // Common Routes
  dashboard: "/dashboard",
  // forbidden_403: "/forbidden-403",

  // Super Admin Routes
  // superAdminDashboard: "/dashboard",

  // Leave Setting
  leaveSetting: "/leave-setting",
  addLeaveSetting: "/add-leave-setting",
  editLeaveSetting: "/edit-leave-setting",

  // Leave
  addLeave: "/add-leave",
  editLeave: "/edit-leave",
  leaveDetail: "/leave-detail",
  teamLeaveDetail: "/team-leave-detail",
  teamLeave: "/team-leave",
  myLeave: "/my-leave",

  // Admin Routes
  adminCompare: "/admin/compare",
  adminOrg: "/admin/org",
  adminTemplates: "/admin/templates",
  adminAudit: "/admin/audit",
  adminSettings: "/admin/settings",

  // Site
  superAdminSite: "/site",
  addSite: "/add-site",
  editSite: "/edit-site",

  // company document
  companyDocument: "/company-documents",
  createCompanyDocument: "/company-documents/create",
  editCompanyDocument: "/company-documents/edit",
  companyDocumentDetail: "/company-documents/view",

  documentSetting: "/document-setting",

  // create salary
  createSalary: "/create-salary",

  // Offboarding
  offboardingList: "/offboarding",
  startOffboarding: "/start-offboarding",
  editOffboarding: "/edit-offboarding",

  // Exit Clearance
  exitClearanceList: "/exit-clearance",
  viewExitClearance: "/exit-clearance-detail",

  // brach user payslip
  branchUserPayslip: "/branch-user-payslip",
};
// };
